<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsInstituicao"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :items="listarAreaDetalhada"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Área Detalhada',
      titleModal: '',
      titlePDF: 'Área Detalhada',
      listarAreaDetalhada: [],
      baseUrlGestaoProjetosConcurso: '',
      instituicao: [],
      itemPorPage: '100',
      fieldsInstituicao: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codareadetalhada', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true }
      ]
    }
  },
  methods: {
    listandoAreaDetalhada: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      this.linstandoAreaDetalhadaGenerico()
        .then((response) => {
          this.listarAreaDetalhada = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoAreaDetalhada()
  }
}
</script>
